import React, { useEffect, useState } from "react";
import { render } from "react-dom";

// Import Highcharts
import Highcharts from "highcharts";
import HCMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import HighchartsReact from "highcharts-react-official";

HCMore(Highcharts);
solidGauge(Highcharts);

const BarLineChart = (props) => {
  const [options, setOptions] = useState({});

  useEffect(() => {
    setOptions({
      chart: {
        type: "column",
        marginTop: -10,
        marginBottom: 100,
      },
      title: {
        text: "",
      },
      exporting: {
        enabled: false,
      },
      xAxis: {
        categories: [
          "Years Experience",
          "Qualifications",
          "Courses",
          "Competency",
          "Skills",
        ],
        labels: {
          enabled: false,
        },
      },
      credits: {
        enabled: false,
      },
      yAxis: {
        min: 0,
        title: {
          text: "",
        },
        labels: {
          enabled: false,
        },
        stackLabels: {
          enabled: false,
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: true,
      },
      plotOptions: {
        column: {
          stacking: "normal",
          dataLabels: {
            enabled: false,
          },
        },
        series: {
          states: {
            inactive: {
              opacity: 1,
            },
          },
        },
      },
      series: [
        {
          name: "Score",
          type: "line",
          data: props.data,
          color: "red",
        },
        {
          name: "Score",
          type: "column",
          data: props.data,
          color: "#26336e",
        },
      ],
    });
  }, [props]);

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      containerProps={{ className: "equal-height-graph" }}
    />
  );
};

export default BarLineChart;
